import { A4uBox as IconComponent } from '@adobe/react-spectrum-workflow/dist/Box.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Box(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}